// T6 — client-side admin-route gating.
//
// Pure-admin routes (e.g. /admin/course-map, the Mapbox course-mapper editor)
// must not render for a signed-in NON-admin who navigates there by URL. The
// real enforcement stays server-side, but leaving the admin UI reachable
// client-side leaks the editor to any authed player — this predicate is the
// single source of truth for "may this player see admin-only surfaces."
//
// Roles mirror the admin checks already used on the commissioner / event-create
// surfaces (players.role text — see CommissionerPage / EventCreatePage):
//   - 'course'        (was the legacy course-admin string pre-D-327)
//   - 'organization'  (was the legacy org-admin string pre-D-327)
//   - 'admin'         (TournyFlex owner; superset of both — D-328)
// NOTE: /event-setup is deliberately NOT gated here — it is a legitimate
// feature open to any signed-in player, with server-side role enforcement at
// write time.
export const ADMIN_ROLES = ['course', 'organization', 'admin']

// True only for a player row whose role is an admin role. Defensive against a
// null/undefined player (auth still resolving) and any non-admin/unknown role —
// both deny access.
export function isAdminRole(role) {
  return ADMIN_ROLES.includes(role)
}

export function canAccessAdminRoutes(player) {
  return isAdminRole(player?.role)
}
